(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-resumable-uploader", ["react"], factory);
	else if(typeof exports === 'object')
		exports["react-resumable-uploader"] = factory(require("react"));
	else
		root["react-resumable-uploader"] = factory(root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_71__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition